import { useBucket } from '@mc/experiments-react'

// https://app.growthbook.io/features/cf-turnstile
const FLAG = 'cf-turnstile'

export const useTurnstile = () => useBucket<'variant_1'>(FLAG)
